<template>
    <div>
        <div>
            <taxSearch :searchdata="searchData" :searchlist="searchList" labelWidth="120px" @submitSearch='getMainProcessPageList'>

            </taxSearch>
        </div>
        <div class="end-flex" style="margin: 16px 0px;">
            <el-button type="primary" @click="exportMainProcess">导出</el-button>
            <el-button type="primary" @click="pushEdi">推送EDI</el-button>
            <el-button type="primary" @click="passMainProcess">通过</el-button>
            <el-button type="primary" @click="cancelMainProcessOp">作废</el-button>
            <el-button type="primary" @click="undoMainProcess">撤回主流程</el-button>
            <el-button type="primary" @click="manualPushEdi">手工推送EDI</el-button>
            <el-button type="primary" @click="repairImage">影像修复</el-button>
        </div>
        <taxtable :headData="headData" ref="mainProcess" showPagination showSelection :tableData="tableData" @sizChange="sizeChange" @currentChange="currentChange" @sortchange="sortChange" :pagination="pagination" :tableHeight="tableHeight">
            <template v-slot:barCode='scope'>
                <div class='customtext' @click='viewMergeImage(scope.taxval.barCode)'>
                    {{ scope.taxval.barCode }}
                </div>
            </template>
            <template v-slot:processNode='scope'>
                <div v-for='(item, index) in processNodeList' :key='index' v-if='scope.taxval.processNode == item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:createTime='scope'>
                {{ timestampToStr(scope.taxval.createTime) }}
            </template>
            <template v-slot:sourceType='scope'>
                <div v-for='(item,index) in sourceTypes' :key='index' v-if='scope.taxval.sourceType == item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:pushStatus='scope'>
                <div v-for='(item,index) in ediPushStatus' :key='index' v-if='scope.taxval.pushStatus == item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:pushDate='scope'>
                {{ timestampToStr(scope.taxval.pushDate) }}
            </template>
            <template v-slot:accountDate='scope'>
                {{ yyyyMMdd(scope.taxval.accountDate) }}
            </template>
        </taxtable>
        <el-dialog title="查看合成影像" :visible.sync="viewMergeImageDialog" :close-on-click-modal='false' :close-on-presss-escape='false' width="75%" height="80%" v-dialogDrag @close='close' append-to-body>
            <div style='height: 580px;'>
                <iframe v-if='notemptyandnull(pdfurl)' :src='pdfurl' scrolling='yes' frameborder='0' style='width: 100%; height: 100%' />
            </div>
        </el-dialog>
        <el-dialog title='主流程作废' :visible.sync='cancelMainProcessDialog' :close-on-click-modal='false' :close-on-press-escape='false' width='450px' height="300px" v-dialogDrag @close='close' append-to-body>
            <div class="Centerupdown">
                <span style="width: 15%">备注：</span>
                <span style="width: 85%;">
                    <el-input v-model="cancelRemark" clearable type="textarea" placeholder="请输入主流程作废备注" :row="3" styl="width: 90%;"></el-input>
                </span>
            </div>
            <div class="horizontally" style="margin-top: 20px;">
                <el-button type='primary' @click='cancelMainProcess'>保存</el-button>
            </div>
        </el-dialog>
    </div>
</template> 

<script>
    import { getCurrentUserCompany, getMainProcessPageList, getMergeImagePath, passMainProcess, cancelMainProcess, undoMainProcess, pushEdi, repairImage } from '../../../api/home'; 
    import http from '../../../../configHttp.js';
    export default {
        name: 'mainProcess',
        data() {
            return {
                searchData: {
                    barCode: '',
                    companyCode: '',
                    processNode: '',    //  流程节点
                    feeType: '',
                    sourceType: '',
                    supplierName: '',
                    batchNo: '',
                    createTime: [],
                    poNumber: '',
                    currency: '',
                    pushStatus: '',
                    voucherNumber: '',
                    accountDate: [] //  记账日期
                },
                searchList: [
                    {
                        type: 'input',
                        label: 'barcode',
                        prop: 'barCode'
                    },
                    {
                        type: 'selectmore',
                        label: '公司代码',
                        prop: 'companyCode',
                        selectval: []
                    },
                    {
                        type: 'selectmore',
                        label: '流程节点',
                        prop: 'processNode',
                        selectval: JSON.parse(JSON.stringify(this.processNodeList))
                    },
                    {
                        type: 'selectmore',
                        label: '费用类型',
                        prop: 'feeType',
                        selectval: JSON.parse(JSON.stringify(this.feeTypes))
                    },
                    {
                        type: 'select',
                        label: '进件渠道',
                        prop: 'sourceType',
                        clearable: true,
                        selectval: JSON.parse(JSON.stringify(this.sourceTypes))
                    },
                    {
                        type: 'input',
                        label: '供应商名称',
                        prop: 'supplierName'
                    },
                    {
                        type: 'input',
                        label: '批次号',
                        prop: 'batchNo'
                    },
                    {
                        type: 'date',
                        label: '创建日期',
                        valueformat: 'timestamp',
                        prop: 'createTime',
                        unlinkpanels: true
                    },
                    {
                        type: 'input',
                        label: 'PO号',
                        prop: 'poNumber'
                    },
                    {
                        type: 'input',
                        label: '币种',
                        prop: 'currency'
                    },
                    {
                        type: 'date',
                        label: '记账日期',
                        valueformat: 'yyyyMMdd',
                        prop: 'accountDate',
                        unlinkpanels: true
                    },
                    {
                        type: 'select',
                        label: 'EDI推送状态',
                        prop: 'pushStatus',
                        clearable: true,
                        selectval: JSON.parse(JSON.stringify(this.ediPushStatus))
                    },
                    {
                        type: 'input',
                        label: '凭证号',
                        prop: 'voucherNumber'
                    },
                    {
                        type: 'date',
                        label: 'EDI推送时间',
                        valueformat: 'timestamp',
                        prop: 'pushDate',
                        unlinkpanels: true
                    }
                ],
                headData: [
                    {
                        title: '公司代码',
                        prop: 'companyCode',
                        issort: true,
                        width: 120
                    },
                    {
                        title: 'barcode',
                        prop: 'barCode',
                        issort: true,
                        width: 180,
                        custom: true
                    },
                    {
                        title: '流程节点',
                        prop: 'processNode',
                        width: 150,
                        custom: true    
                    },
                    {
                        title: '供应商名称',
                        prop: 'supplierName',
                        width: 200
                    },
                    {
                        title: '发票金额（不含税）',
                        prop: 'amount',
                        width: 180
                    },
                    {
                        title: '发票税额',
                        prop: 'tax',
                        width: 180
                    },
                    {
                        title: '发票金额（含税）',
                        prop: 'totalAmount',
                        width: 180
                    },
                    {
                        title: 'PO号',
                        prop: 'poNumber',
                        width: 160
                    },
                    {
                        title: '币种',
                        prop: 'currency',
                        width: 120
                    },
                    {
                        title: '批次号',
                        prop: 'batchNo',
                        width: 160
                    },
                    {
                        title: '费用类型',
                        prop: 'feeType',
                        width: 80
                    },
                    {
                        title: '备注',
                        prop: 'remark',
                        width: 150
                    },
                    {
                        title: '创建时间',
                        prop: 'createTime',
                        width: 160,
                        issort: true,
                        custom: true
                    },
                    {
                        title: '进件渠道',
                        prop: 'sourceType',
                        width: 120,
                        custom: true
                    },
                    {
                        title: 'EDI推送状态',
                        prop: 'pushStatus',
                        width: 100,
                        custom: true
                    },
                    {
                        title: 'EDI推送时间',
                        prop: 'pushDate',
                        width: 160,
                        custom: true
                    },
                    {
                        title: '记账日期',
                        prop: 'accountDate',
                        width: 120,
                        custom: true
                    },
                    {
                        title: '凭证号',
                        prop: 'voucherNumber',
                        width: 160
                    },
                    {
                        title: '凭证税金',
                        prop: 'voucherTax',
                        width: 160
                    },
                    {
                        title: '比对异常说明',
                        prop: 'exceptionDesc',
                        width: 200
                    }
                ],
                tableData: [],
                pagination: {
                    pageNum: 0,
                    pageSize: 300,
                    total: 0,
                    sort: '',
                    order: '',
                },
                sortField: {    //  排序的字段
                    companyCode: 'company_code',
                    barCode: 'bar_code',
                    createTime: 'create_time'
                },
                viewMergeImageDialog: false,
                pdfurl: '',
                tableHeight: 0,
                cancelMainProcessDialog: false,
                cancelRemark: ''
            }
        },
        created() {
            this.getCurrentUserCompany();
            this.getMainProcessPageList();
        },
        mounted() {
            this.repairtable()
        },
        methods: {
            sizeChange(pageSize) {
                this.pagination.pageSize = pageSize;
                this.getMainProcessPageList()
            },
            currentChange(pageNum) {
                this.pagination.pageNum = pageNum;
                this.getMainProcessPageList()
            },
            sortChange(data) {
                this.pagination.sort = this.sortField[data.prop];
                this.pagination.order = data.order == 'ascending' ? 'asc' : 'desc';
                this.getMainProcessPageList();
            },
            getCurrentUserCompany() {
                getCurrentUserCompany().then(res => {
                    let companyList = res.data.data;
                    let searchList = JSON.parse(JSON.stringify(this.searchList));
                    searchList[1].selectval = companyList.map(item => {
                        item.label = item.code;
                        item.value = item.code;
                        return item;
                    });
                    this.searchList = JSON.parse(JSON.stringify(searchList));
                    console.log(this.searchList);
                });
            },
            getMainProcessPageList() {
                this.pagination.search = this.searchData;
                getMainProcessPageList(this.pagination).then(res => {
                    this.tableData = res.data.data.records;
                    this.pagination.total = res.data.data.total;
                });
            },
            exportMainProcess() {
                let params = this.searchData;
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                checkedData.forEach((item, index) => {
                    idList.push(item.id);
                });
                params.ids = idList.join(',');

                let downloadUrl = http.baseURL + "process/main/exportMainProcess";
                let obj = {
                    downUrl: downloadUrl,
                    typeObj: {
                        toForm: false,
                        fileType: 'xlsx'
                    },
                    params: params
                }
                this.$downloadcommon(obj)
            },
            viewMergeImage(barCode) {   //  查看合成影像
                this.viewMergeImageDialog = true;
                getMergeImagePath({ barCode: barCode }).then(res => {
                    if(res.data.success) {
                        this.pdfurl = res.data.data;
                        this.pdfurl = this.pdfurl.replace(/\\/g, '/');
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            },
            passMainProcess() { //  通过
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                if(!checkedData || checkedData.length == 0) {
                    this.$message.warning('请选择需要通过的主流程信息！');
                    return;
                }
                let flag = true;
                for(let i = 0;i < checkedData.length; i++) {
                    if(checkedData[i].processNode != '1') {
                        this.$message.warning('存在无需操作的流程节点！');
                        flag = false;
                        break;
                    }
                    idList.push(checkedData[i].id);
                }
                if(flag == true) {
                    passMainProcess(idList.join(',')).then(res => {
                        if(res.data.success) {
                            this.$message.success("操作成功！");
                            this.getMainProcessPageList();
                        } else {
                            this.$message.error("操作失败：" + res.data.message);
                        }
                        this.getMainProcessPageList();
                    });
                }
            },
            cancelMainProcessOp() {
                let checkedData = this.$refs.mainProcess.getSelectionval();
                if(!checkedData || checkedData.length == 0) {
                    this.$message.warning('请选择需要作废的主流程信息！');
                    return;
                }
                this.cancelMainProcessDialog = true;
            },
            cancelMainProcess() {   //  作废
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                checkedData.forEach((item, index) => {
                    idList.push(item.id);
                });
                this.$confirm('确认是否需要作废选中的主流程信息?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        ids: idList.join(','),
                        remark: this.cancelRemark
                    }
                    cancelMainProcess(params).then(res => {
                        if(res.data.success) {
                            this.$message.success("操作成功！");
                            this.getMainProcessPageList();
                        } else {
                            this.$message.error("操作失败：" + res.data.message);
                        }
                        this.cancelMainProcessDialog = false;
                    })
                });
            },
            undoMainProcess() {
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                if(!checkedData || checkedData.length == 0) {
                    this.$message.warning('请选择需要撤销的主流程信息！');
                    return;
                }
                checkedData.forEach((item, index) => {
                    idList.push(item.id);
                });
                undoMainProcess(idList.join(',')).then(res => {
                    if(res.data.success) {
                        this.$message.success("操作成功！");
                        this.getMainProcessPageList();

                    } else {
                        this.$message.error("操作失败：" + res.data.message);
                    }
                });
            },
            pushEdi() { //  推送edi
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                if(!checkedData || checkedData.length == 0) {
                    this.$message.warning('请选择需要推送EDI的主流程信息！');
                    return;
                }
                let flag = true;
                for(let i = 0;i < checkedData.length; i++) {
                    if(checkedData[i].pushStatus == '1') {
                        this.$message.warning('已推送的主流程信息不可重复推送！');
                        flag = false;
                        break;
                    }
                    idList.push(checkedData[i].id);
                }
                if(flag == true) {
                    pushEdi(idList.join(',')).then(res => {
                        if(res.data.success) {
                            if(res.data.message) {
                                this.$message.warning(res.data.message);
                            } else {
                                this.$message.success("推送EDI成功");
                            }
                            this.getMainProcessPageList();
                        } else {
                            this.$message.error("推送EDI失败：" + res.data.message);
                        }
                    });
                }
            },
            manualPushEdi() {   //  手工推送edi
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                if(!checkedData || checkedData.length == 0) {
                    this.$message.warning('请选择需要推送EDI的主流程信息！');
                    return;
                }
                for(let i = 0;i < checkedData.length; i++) {
                    idList.push(checkedData[i].id);
                }
                pushEdi(idList.join(',')).then(res => {
                    if(res.data.success) {
                        if(res.data.message) {
                            this.$message.warning(res.data.message);
                        } else {
                            this.$message.success("推送EDI成功");
                        }
                        this.getMainProcessPageList();
                    } else {
                        this.$message.error("推送EDI失败：" + res.data.message);
                    }
                });
            },
            repairImage() { //  影像修复
                let idList = [];
                let checkedData = this.$refs.mainProcess.getSelectionval();
                if(!checkedData || checkedData.length == 0 || checkedData.length > 1) {
                    this.$message.warning('请选择一条需要影像修复的主流程信息！');
                    return;
                }
                for(let i = 0;i < checkedData.length; i++) {
                    idList.push(checkedData[i].id);
                }
                repairImage(idList.join(',')).then(res => {
                    if(res.data.success) {
                        if(res.data.message) {
                            this.$message.warning(res.data.message);
                        } else {
                            this.$message.success("影像修复成功");
                        }
                        this.getMainProcessPageList();
                    } else {
                        this.$message.error("影像修复失败：" + res.data.message);
                    }
                })
            },
            repairtable() {
                this.$nextTick(() => {
                    this.tableHeight = this.diagheightshenghe();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                    window.onresize = () => {
                        this.tableHeight = this.diagheightshenghe();
                        setTimeout(() => {
                            this.$refs.multipleTable.doLayout();
                        }, 300);
                    };
                });
            }
        }
    }
</script>